import Pristine from "../vendor/pristine.min.cjs";

function resetTurnstile() {
  if (!window.turnstile) {
    return;
  }

  const widget = document.getElementById("contact-turnstile");
  if (widget) {
    window.turnstile.reset(widget);
  }
}

function setContactFormStatus(message, isError) {
  const status = document.getElementById("contactFormStatus");
  if (!status) {
    return;
  }

  status.textContent = message;
  status.hidden = false;
  status.classList.toggle("text-danger", isError);
  status.classList.toggle("text-success", !isError);
}

function clearContactFormStatus() {
  const status = document.getElementById("contactFormStatus");
  if (!status) {
    return;
  }

  status.textContent = "";
  status.hidden = true;
  status.classList.remove("text-danger", "text-success");
}

function initContactForm() {
  const contactForm = document.getElementById("contactForm");
  if (!contactForm) {
    return;
  }

  const pristine = new Pristine(contactForm);
  const submitButton = contactForm.querySelector('button[type="submit"]');

  async function handleContactSubmit(event) {
    event.preventDefault();
    clearContactFormStatus();

    if (!pristine.validate()) {
      return;
    }

    if (!contactForm.querySelector('[name="cf-turnstile-response"]')?.value) {
      setContactFormStatus("Please complete the verification check.", true);
      return;
    }

    submitButton.disabled = true;

    try {
      const response = await fetch("/api/contact", {
        method: "POST",
        body: new FormData(contactForm),
      });

      if (response.ok) {
        contactForm.reset();
        resetTurnstile();
        setContactFormStatus("Thanks — we'll be in touch.", false);
        return;
      }

      setContactFormStatus(
        "Something went wrong. Please try again in a moment.",
        true,
      );
    } catch {
      setContactFormStatus(
        "Something went wrong. Please try again in a moment.",
        true,
      );
    } finally {
      submitButton.disabled = false;
    }
  }

  contactForm.addEventListener("submit", handleContactSubmit);
}

window.addEventListener("load", initContactForm);
